import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	LandingTitle,
	otpStyle,
} from "../../lib/styles/styleLibrary";
import { Button, InputNumber, Statistic } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router";
import { isEmpty, Toast, ValidateEmail } from "../../lib/helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import { getAuth } from "../../redux/reducers/authReducer";
import { ROUTES } from "../../settings/routes";
import {
	resendVerificationMail,
	verifyUser,
} from "../../redux/actions/authentication";

import { PageLoading } from "../../components/Loading/Loading";
import Auth from "../../lib/middleware/auth";
import { COLORS } from "../../lib/styles/styles";

const Wrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const VerifyAccount = (props) => {
	const dispatch = useDispatch();
	const auth = useSelector(getAuth);
	const experience = Auth.getExperience();
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const emailParams = searchParams.get("email");
	const codeParams = searchParams.get("code");

	const [user, setUser] = useState({});
	const [loading, setLoading] = useState(false);
	const [pageLoading, setPageLoading] = useState(false);
	const [resend, setResend] = useState(false);
	const [rc, rcl] = useState(false);
	const { Countdown } = Statistic;
	const [code, setCode] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});

	useEffect(() => {
		if (isEmpty(location.state)) {
			return;
		}
		// location.state !== undefined && 	setUser(location.state.user);
		setUser(location.state.user);
	}, [location?.state]);
	console.log("User from route data", user);

	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			const next = elmnt.target.tabIndex - 2;

			if (next > -1) {
				elmnt.target.form.elements[next].focus();
			}
		} else {
			const next = elmnt.target.tabIndex;
			if (next < 5) {
				elmnt.target.form.elements[next].focus();
			}
		}
	};

	useEffect(() => {
		if (isEmpty(emailParams) || isEmpty(codeParams)) {
			return;
		}
		setCode({
			...code,
			otp1: codeParams[0],
			otp2: codeParams[1],
			otp3: codeParams[2],
			otp4: codeParams[3],
		});
		const credentials = {
			email: emailParams,
			code: codeParams,
		};
		console.log(credentials);
		setLoading(true);
		setPageLoading(true);
		dispatch(verifyUser(credentials));
		// eslint-disable-next-line
	}, [emailParams, codeParams]);

	useEffect(() => {
		try {
			if (!resend) {
				return;
			}
			const { error, message, title } = auth;
			if (error) {
				Toast.fire({
					icon: "error",
					title: `${title}
					${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${title}
					${message}`,
				});
			}
		} catch (error) {
		} finally {
			setInterval(() => {
				setResend(false);
			}, 20000);
		}
	}, [resend, auth]);

	const handleVerify = (e) => {
		e.preventDefault();
		const data = `${code.otp1}${code.otp2}${code.otp3}${code.otp4}`;
		if (data.length < 4 || isNaN(data)) {
			Toast.fire({
				icon: "error",
				title: `Invalid code`,
			});
			return;
		}
		const credentials = {
			email: user?.email,
			code: data,
		};
		console.log(credentials);
		setLoading(true);
		dispatch(verifyUser(credentials));
	};

	const handleResend = (e) => {
		e.preventDefault();
		const data = {
			email: user?.email,
		};
		console.log(data);
		if (!ValidateEmail(data.email)) {
			Toast.fire({
				icon: "error",
				title: `Email is not valid`,
			});
			return;
		}
		setResend(true);
		rcl(true);
		dispatch(resendVerificationMail(data));
		setTimeout(() => {
			rcl(false);
		}, 20000);
	};

	console.log(auth);

	useEffect(() => {
		try {
			if (!loading) {
				return;
			}
			setLoading(false);
			setPageLoading(false);
			const { error, message, title } = auth;
			if (error) {
				return Toast.fire({
					icon: "error",
					title: `${title}
					${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${title}
					${message}`,
				});
				setTimeout(() => {
					history.push(ROUTES.ACCOUNTSETUP);
				}, 500);
			}
		} catch (error) {}
		// eslint-disable-next-line
	}, [auth]);

	const handleRoute = () => {
		isEmpty(experience) && auth.isAuth
			? history.push({
					pathname: ROUTES.ACCOUNTSETUP,
					state: { user },
			  })
			: !isEmpty(experience) && auth.isAuth
			? history.push({
					pathname: ROUTES.DASHBOARD,
			  })
			: history.goBack();
	};

	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col!">
				<Wrapper>
					<ArrowLeftOutlined
						tw="p-3 bg-gray-100 mb-12 rounded-full hover:bg-white"
						onClick={() => handleRoute()}
					/>

					<LandingTitle>Verification</LandingTitle>

					<div tw="pt-8">
						<p tw="text-lg">
							We’ve sent the verification code to <br />
							<b>
								{user.email
									? user.email
									: emailParams
									? emailParams
									: "your mail"}
							</b>
						</p>
					</div>

					<div tw="w-full">
						<form
							tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12"
							onSubmit={handleVerify}>
							<div tw="flex flex-row flex-nowrap items-center justify-between">
								<InputNumber
									name="otp1"
									type="text"
									autoComplete="off"
									value={code.otp1}
									placeholder="-"
									css={otpStyle}
									onChange={(e) => {
										setCode({ ...code, otp1: e });

										console.log(e);
									}}
									tabIndex="1"
									min="0"
									maxLength="1"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp2"
									type="number"
									autoComplete="off"
									css={otpStyle}
									value={code.otp2}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp2: e,
										})
									}
									tabIndex="2"
									min="0"
									maxLength="1"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp3"
									type="number"
									autoComplete="off"
									css={otpStyle}
									value={code.otp3}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp3: e,
										})
									}
									tabIndex="3"
									maxLength="1"
									min="0"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp4"
									type="number"
									css={otpStyle}
									autoComplete="off"
									value={code.otp4}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp4: e,
										})
									}
									tabIndex="4"
									maxLength="1"
									min="0"
									onKeyUp={(e) => inputfocus(e)}
								/>
							</div>
							<button type="submit" tw="mt-8 h-12" css={btnStyle}>
								{loading ? <Loading /> : "Continue"}
							</button>

							<div tw="flex flex-row items-center justify-center mt-8 ">
								<Button
									type="link"
									tw="text-base text-appTextDark pr-1"
									onClick={handleResend}
									disabled={resend}>
									Re-send code{" "}
									{resend && <span tw="pl-1">in</span>}
								</Button>
								{rc && (
									<span tw="inline-flex items-center justify-center  text-appPink gap-1">
										<Countdown
											tw="text-sm text-appPink"
											format="m:ss"
											value={Date.now() + 20 * 1000}
											valueStyle={{
												color: COLORS.appPink,
											}}
										/>
									</span>
								)}
							</div>
						</form>
					</div>
				</Wrapper>{" "}
			</div>
			{pageLoading && <PageLoading />}
		</LandingLayout>
	);
};

export default VerifyAccount;
